import { GlobalResponseObject } from "@gtpl/shared-models/common-models";

export class assignSoakingForFreezingResponse extends GlobalResponseObject{
    data?: boolean;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: boolean) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}